interface MarkOptions {
  detail?: any;
  startTime?: DOMHighResTimeStamp;
}

export function markStep(performance: Performance, markName: string, _options?: MarkOptions) {
  performance.mark(markName);
}
